import CatalogRelease from '../../../../../common/types/catalog/catalog-release';

export const isCatalogEntryLocked = (item: CatalogRelease) => {
  return item.isLocked || item.tracks.some((track) => track.isLocked);
};
